<template>
  <div>
    <!-- Filtro -->
    <div class="d-flex align-items-center">
      <ui-select
        class="w-100 mr-3"
        has-search
        label="Modulo"
        placeholder="Seleccionar"
        searchPlaceholder="Buscar"
        :keys="{ value: 'id', label: 'name' }"
        :options="listaSecciones"
        v-model="moduloSelected"
        @change="filtrarSeleccion(moduloSelected)"
      ></ui-select>

      <Button
        icon="fas fa-undo-alt"
        color="red"
        colorText="#fff"
        :width="35"
        round
        title="Quitar selección"
        @click.native="limpiar()"
      />
    </div>
    <div style="border-top: solid 1px #d8d8d8">
      <div class="d-flex flex-column p-3">
        <!-- Loading tabla -->
        <div
          class="d-flex justify-content-center w-100"
          style="margin-top: 110px"
          v-if="loadingTable"
        >
          <loading />
        </div>
        <!-- dataTable y botones -->
        <div
          class="d-flex flex-row flex-wrap justify-content-start mb-2"
          v-else
        >
          <div style="position: relative; z-index: 5">
            <div class="d-flex" style="position: absolute">
              <agregar-sub-seccion-modal
                :listaSecciones="dataSecciones"
                :listaModulos="listaModulos"
              />
            </div>
          </div>
          <!-- Datatable -->
          <data-table
            v-if="acciones.length > 0"
            :headers="headers"
            :data="dataAux"
            :acciones="acciones"
            :max="10"
            paginacion
            buscar
            exportarExcel
            idtabla="sub_secciones"
            :seleccionar="obtenerFilaSeleccionada"
          />

          <not-found-table
            v-else
            :text="'No se encontraron registros de sub secciones'"
            class="justify-content-center w-100 pt-5"
          />
        </div>
      </div>
      <!-- Modales para acciones para filas -->
      <actualizar-sub-seccion-modal
        :data="dataSubSeccionActualizar"
        :listaSecciones="dataSecciones"
        :listaModulos="listaModulos"
      />
    </div>
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";

// Components
import DataTable from "../../../common/DataTable";
import UiSelect from "keen-ui/src/UiSelect";
import Button from "../../../common/Button";

import AgregarSubSeccionModal from "../../../modals/superadministrador/Secciones/AgregarSubSeccionModal";
import ActualizarSubSeccionModal from "../../../modals/superadministrador/Secciones/ActualizarSubSeccionModal";

// Not Found
import NotFoundTable from "../../../common/NotFoundTable";

// Contants
import {
  getSubSecciones,
  activarDesactivarSubSeccion,
  deleteSubSeccion,
} from "../../../../constants/superadministrador";

export default {
  props: ["listaSecciones", "listaModulos"],
  data() {
    return {
      data: [],
      headers: [
        "Nombre",
        "Referencia",
        "Modulo",
        "Creación",
        "Modificado por",
        "Fecha creación",
        "Ultima modificación",
        "Acciones",
      ],
      acciones: [],
      moduloSelected: [],
      dataSecciones: [],
      dataAux: this.data,
      dataSubSeccionActualizar: [],
    };
  },
  components: {
    DataTable,
    UiSelect,
    Button,
    AgregarSubSeccionModal,
    ActualizarSubSeccionModal,
    NotFoundTable,
  },
  computed: {
    ...mapState(["loading", "loadingTable", "token"]),
    ...mapState("superadministrador", ["dataDatatableSubSeccionesFiltrada"]),
  },
  methods: {
    ...mapActions("superadministrador", [
      "actionSetDataSubSecciones",
      "ActionSetVisibleModalEditarSubSeccion",
    ]),

    async obtenerSubSecciones() {
      let { data_table } = await getSubSecciones();

      this.data = data_table;
      this.dataAux = data_table;

      data_table.map((item) => {
        this.dataSecciones.push({
          id: item.data_complementaria.id_seccion,
          name: item.data[0],
          id_parent: item.data_complementaria.id_parent,
          id_module: item.data_complementaria.id_module,
        });
      });

      this.generarBotonesAcciones();
    },

    async generarBotonesAcciones() {
      let me = this;

      await me.dataAux.map((item, index) => {
        let estado_subseccion = item.data_complementaria.estado;

        me.acciones.push([
          {
            icon: "fa fa-edit",
            title: "Editar",
            id: index,
          },
          {
            icon:
              estado_subseccion == 1
                ? "fa fa-eye text-success"
                : "fa fa-eye-slash text-danger",
            title: estado_subseccion == 1 ? "Desactivar" : "Activar",
            id: index,
          },
          {
            icon: "fa fa-times text-danger",
            title: "Eliminar",
            id: index,
          },
        ]);
      });
    },

    async actualizacionGenerarBotonesAcciones() {
      let me = this;

      me.acciones = [];

      await me.dataAux.map((item, index) => {
        let estado_subseccion = item.data_complementaria.estado;

        me.acciones.push([
          {
            icon: "fa fa-edit",
            title: "Editar",
            id: index,
          },
          {
            icon:
              estado_subseccion == 1
                ? "fa fa-eye text-success"
                : "fa fa-eye-slash text-danger",
            title: estado_subseccion == 1 ? "Desactivar" : "Activar",
            id: index,
          },
          {
            icon: "fa fa-times text-danger",
            title: "Eliminar",
            id: index,
          },
        ]);
      });
    },

    obtenerFilaSeleccionada(fila) {
      let textoAuxiliar = "";
      let data_fila = this.data[fila.id];
      let id_subseccion = this.dataAux[fila.id].data_complementaria.id_seccion;
      let nombre_subseccion = this.dataAux[fila.id].data[0];
      let estado_subseccion = this.dataAux[fila.id].data_complementaria.estado;

      if (fila.accion == "Editar") {
        /*

        */
        this.dataSubSeccionActualizar = data_fila;
        this.ActionSetVisibleModalEditarSubSeccion(true);
        /*
        /*

        */
      } else if (fila.accion == "Activar" || fila.accion == "Desactivar") {
        /*
        
        */

        if (estado_subseccion == 1) {
          textoAuxiliar =
            "¿Desea desactivar la Subsección '" + nombre_subseccion + "'?";
        } else {
          textoAuxiliar =
            "¿Desea activar la Subsección '" + nombre_subseccion + "'?";
        }

        //
        this.$vToastify.prompt(textoAuxiliar).then(
          (respuesta) =>
            respuesta &&
            this.deshabilitarSubSeccion(
              id_subseccion,
              fila.accion,
              estado_subseccion
            ) // id, accion, estado de pallet
        );
      } else if (fila.accion == "Eliminar") {
        /*

        */
        this.$vToastify
          .prompt(`¿Desea eliminar la Subsección '${nombre_subseccion}'?`)
          .then(
            (respuesta) => respuesta && this.eliminarSubSeccion(id_subseccion)
          );

        /*

        */
      }
    },

    async eliminarSubSeccion(id) {
      let sql = await deleteSubSeccion({ id });

      if (!sql.error) {
        // Consulta nuevamente a la API para obtener la nueva data
        let dataSubSeccionesDB = await getSubSecciones();

        // Actualizar los datos del dataTable
        this.actionSetDataSubSecciones(dataSubSeccionesDB.data_table);

        this.dataAux = dataSubSeccionesDB.data_table;

        this.$vToastify.success(
          "Subsección eliminada correctamente",
          "¡Realizado!"
        );

        this.actualizacionGenerarBotonesAcciones();
      } else {
        console.log("Error");
      }
    },

    async deshabilitarSubSeccion(id, accion, estado) {
      //
      let sql = await activarDesactivarSubSeccion({ id, estado });

      let texto = accion == "Activar" ? "activada" : "desactivada";

      if (!sql.error) {
        // Consulta nuevamente a la API para obtener la nueva data
        let dataSubSeccionesDB = await getSubSecciones();

        // Actualizar los datos del dataTable
        this.actionSetDataSubSecciones(dataSubSeccionesDB.data_table);

        this.$vToastify.success(
          "Subsección " + texto + " correctamente",
          "¡Realizado!"
        );

        this.actualizacionGenerarBotonesAcciones();
      } else {
        console.log("Error");
      }
    },

    filtrarSeleccion(item) {
      let aux = this.data.filter(
        (seccion) => item.id == seccion.data_complementaria.id_parent
      );

      this.dataAux = aux;
    },

    limpiar() {
      this.moduloSelected = [];
      this.dataAux = this.data;
    },
  },
  created() {
    this.obtenerSubSecciones();
  },
  watch: {
    dataDatatableSubSeccionesFiltrada: function (_new) {
      let me = this;

      // Si watch detecta un cambio en la variable dataDatatableFilialesFiltrada la cual es un state de vuex, esta asignada el nuevo
      // valor a la variable data
      if (_new) {
        me.data = _new;
        me.dataAux = _new;
        this.actualizacionGenerarBotonesAcciones();
      }
    },
  },
};
</script>

<style></style>
